const MEMBER_REQUEST_SET = 'MEMBER_REQUEST_SET';
const MEMBER_REQUEST_REMOVE = 'MEMBER_REQUEST_REMOVE';

export {
  MEMBER_REQUEST_SET,
  MEMBER_REQUEST_REMOVE,
};



// WEBPACK FOOTER //
// ./src/app/actions/member-request/types.js